
import {HttpRequest,HttpMethod} from "./http";

class PlatformProvider extends HttpRequest {

	ConnectPlatform(params) {
		return this.request(HttpMethod.Post,`/api/platform/${params}/connect` );
	}

	SyncProduct(params) {
		return this.request(HttpMethod.Post,`/api/platform/${params.platform}/products/sync?shop_id=${params.shop_id}`, params);
	}

	SyncOrder(params) {
		return this.request(HttpMethod.Post,`/api/platform/${params.platform}/orders/sync?shop_id=${params.shop_id}&shop_name=${params.shop_name}`, params);
	}

	ListSeller(params) {
		return this.request(HttpMethod.Get,`/api/platform/seller` );
	}

	RefreshToken(params) {
		return this.request(HttpMethod.Post,`/api/platform/${params.platform}/refreshtoken?shop_id=${params.shop_id}` );
	}
}

export default PlatformProvider